import type { PluginListenerHandle } from '@capacitor/core';

export type ProtocolType = 'tcp' | 'udp';
export interface NetWorkPlugin {
  connect(options: { type: ProtocolType, ip: string, port: number }): Promise<void>;
  disconnect(): Promise<void>;
  send(options: { data: string; ip?: string; udpType?: 'broadcast' | 'multicast' | 'singelcast' }): Promise<void>;
  getIpInfo(): Promise<{ ip: string, ipv4: string, ipv6: string }>;
  addListener<T>(eventName: 'data', listenerFunc: (data: T) => void): Promise<PluginListenerHandle>;
  addListener(eventName: 'disconnected', listenerFunc: (data: { type: ProtocolType, port: number, ip?: string }) => void): Promise<PluginListenerHandle>;
  addListener(eventName: 'connected', listenerFunc: (data: { type: ProtocolType, port: number, ip?: string }) => void): Promise<PluginListenerHandle>;
}
